/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Une ligne de la liste des leads externes (prospects captés chez un partenaire apporteur). Périmètre serveur : un gestionnaire voit les leads de SON plateforme traitante, un admin voit tout — le front n'envoie aucun scope.
 * 
 * @export
 * @interface LeadExterneListItemDto
 */
export interface LeadExterneListItemDto {
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    id: string;
    /**
     * Date de capture du lead — INSTANT (ISO avec Z) à convertir au fuseau navigateur
     * @type {Date}
     * @memberof LeadExterneListItemDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    statusId?: string | null;
    /**
     * Code stable du statut (NV = Nouveau, ...)
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    statusCode: string;
    /**
     * Libellé prêt à afficher
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    statusLabel: string;
    /**
     * Couleur du référentiel (hex) — à utiliser directement pour le badge
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    statusColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    branchCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    branchLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    tunnelCode?: string | null;
    /**
     * Partenaire apporteur (origine du lead)
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    partnerPlateformeName?: string | null;
    /**
     * Plateforme traitante
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    plateformeName?: string | null;
    /**
     * Courtier affecté (null tant que le lead n'est pas converti)
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    brokerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    brokerName?: string | null;
    /**
     * Souscripteur (civilité + prénom + nom)
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    subscriber: string;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    phone?: string | null;
    /**
     * Commentaire libre saisi à la capture
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    comment?: string | null;
    /**
     * Prix annuel TTC RECALCULÉ à la capture (jamais celui du partenaire). Absent si le snapshot de tarification est illisible.
     * 
     * @type {number}
     * @memberof LeadExterneListItemDto
     */
    annualPriceInclTax?: number | null;
    /**
     * Lead déjà matérialisé en simulation (riskId renseigné)
     * @type {boolean}
     * @memberof LeadExterneListItemDto
     */
    isConverted: boolean;
    /**
     * Simulation issue de la conversion (présent si isConverted)
     * @type {string}
     * @memberof LeadExterneListItemDto
     */
    riskId?: string | null;
}

/**
 * Check if a given object implements the LeadExterneListItemDto interface.
 */
export function instanceOfLeadExterneListItemDto(value: object): value is LeadExterneListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('subscriber' in value) || value['subscriber'] === undefined) return false;
    if (!('isConverted' in value) || value['isConverted'] === undefined) return false;
    return true;
}

export function LeadExterneListItemDtoFromJSON(json: any): LeadExterneListItemDto {
    return LeadExterneListItemDtoFromJSONTyped(json, false);
}

export function LeadExterneListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadExterneListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'statusCode': json['statusCode'],
        'statusLabel': json['statusLabel'],
        'statusColor': json['statusColor'] == null ? undefined : json['statusColor'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'branchLabel': json['branchLabel'] == null ? undefined : json['branchLabel'],
        'tunnelCode': json['tunnelCode'] == null ? undefined : json['tunnelCode'],
        'partnerPlateformeName': json['partnerPlateformeName'] == null ? undefined : json['partnerPlateformeName'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
        'subscriber': json['subscriber'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'annualPriceInclTax': json['annualPriceInclTax'] == null ? undefined : json['annualPriceInclTax'],
        'isConverted': json['isConverted'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function LeadExterneListItemDtoToJSON(json: any): LeadExterneListItemDto {
    return LeadExterneListItemDtoToJSONTyped(json, false);
}

export function LeadExterneListItemDtoToJSONTyped(value?: LeadExterneListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString()),
        'statusId': value['statusId'],
        'statusCode': value['statusCode'],
        'statusLabel': value['statusLabel'],
        'statusColor': value['statusColor'],
        'branchCode': value['branchCode'],
        'branchLabel': value['branchLabel'],
        'tunnelCode': value['tunnelCode'],
        'partnerPlateformeName': value['partnerPlateformeName'],
        'plateformeName': value['plateformeName'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'subscriber': value['subscriber'],
        'email': value['email'],
        'phone': value['phone'],
        'comment': value['comment'],
        'annualPriceInclTax': value['annualPriceInclTax'],
        'isConverted': value['isConverted'],
        'riskId': value['riskId'],
    };
}

